import { getYesNoOptions, RadioGroup, Slider, TextArea, Typography } from '../../../../components';
import { ComponentSize, QuestionType, TextColor } from '../../../../types';

const TEXT_AREA_MAX_ROWS = 3;
const TEXT_AREA_MIN_ROWS = 2;

interface ScorecardQuestionProps {
  id: string;
  text: string;
  answer: string;
  type?: QuestionType;
  points?: number | null;
  onAnswerChange?: (questionId: string, value: string) => void;
}

const ScorecardQuestion = ({ id, text, answer, points, type, onAnswerChange }: ScorecardQuestionProps) => {
  const isEditMode = !!onAnswerChange;
  return (
    <div className="flex items-center gap-4">
      <div className="flex w-1/2 flex-col gap-1">
        <Typography>{text}</Typography>
        {/* We explicitly check for number because it can be 0 */}
        {typeof points === 'number' && (
          <Typography color={TextColor.TERTIARY}>
            {points} point{Math.abs(points) === 1 ? '' : 's'}
          </Typography>
        )}
      </div>
      <div className="w-1/2">
        {type === QuestionType.RANGE && (
          <Slider
            size={ComponentSize.MEDIUM}
            value={Number(answer) || 1}
            disabled={!isEditMode}
            onChange={(value) => onAnswerChange?.(id, value.toString())}
          />
        )}
        {type === QuestionType.YES_NO && (
          <RadioGroup
            options={getYesNoOptions(true)}
            value={answer}
            isViewMode={!isEditMode}
            onChange={(e) => onAnswerChange?.(id, e.target.value)}
          />
        )}
        {type === QuestionType.TEXT && (
          <TextArea
            value={answer}
            onChange={(e) => onAnswerChange?.(id, e.target.value)}
            placeholder="Type here"
            size={ComponentSize.MEDIUM}
            rows={TEXT_AREA_MIN_ROWS}
            maxRows={TEXT_AREA_MAX_ROWS}
            disabled={!isEditMode}
            fitContent
          />
        )}
      </div>
    </div>
  );
};

export default ScorecardQuestion;
